module.exports = __webpack_public_path__ + "img/local-24.a6856515.jpg";